// The bundle accordions publish their pool and their filter tabs as globals from the section's inline
// Liquid script (`accordionCarouselProducts{n}` / `accordionCarouselFilters{n}`). Both the accordion
// shell and the carousel need to reason about them, so the reads and the collection predicate live here
// rather than being duplicated on either side.

export const getBundleProducts = (bundleIndex) => window[`accordionCarouselProducts${bundleIndex}`] || []

export const getBundleFilters = (bundleIndex) => window[`accordionCarouselFilters${bundleIndex}`] || []

export const filterProductsByCollection = (products, collectionId) =>
  products.filter((product) =>
    Array.isArray(product.collections) && product.collections.some((collection) => collection.id === collectionId)
  )

// A filter tab only counts if it yields at least one product from that accordion's own pool. The tabs
// and the pool are configured independently, so a size can be offered that the pool can't answer -- a
// "King Single" mattress tab on an accordion holding no King Single mattress renders a blank slider.
export const filterHasProducts = (bundleIndex, filterIndex) => {
  const filter = getBundleFilters(bundleIndex)[filterIndex]
  return !!filter && filterProductsByCollection(getBundleProducts(bundleIndex), filter.collectionId).length > 0
}

export const getFirstPopulatedFilterIndex = (bundleIndex) =>
  getBundleFilters(bundleIndex).findIndex((_, index) => filterHasProducts(bundleIndex, index))
